angular.module('impactx.search').directive('ixCategoryFilterSelection', function () {
    return {
        restrict: 'E',
        controller: 'CategoryFilterSelectionCtrl',
        controllerAs: 'categoryFilterSelectionCtrl',
        templateUrl: 'modules/search/templates/category-filter-selection.tmpl.html',
        bindToController: {
            inputName: "@",
            ngModel: "=",
            onItemChange: "&",
            items: "=",
            placeholder: "@",
            containerClass: "@"
        },
        link: function (scope, element, attr, ctrl) {
            ctrl.mdAutocompleteCtrl = element.find('md-autocomplete').controller('mdAutocomplete');
            scope.$watch('categoryFilterSelectionCtrl.mdAutocompleteCtrl.index', function (newValue, oldValue) {
                    if (!angular.equals(newValue, oldValue)) {
                        if (ctrl.mdAutocompleteCtrl.index === 0 && ctrl.mdAutocompleteCtrl.matches.length === 0) {
                            ctrl.ngModel = undefined;
                            angular.element('#' + ctrl.inputName).blur();
                            if (angular.isFunction(ctrl.onItemChange)) {
                                ctrl.onItemChange();
                            }
                        }
                    }
                }
            );
            scope.$watch("categoryFilterSelectionCtrl.ngModel", function (newValue) {
                if (newValue) {
                    ctrl.searchText = newValue.name;
                }
                else{
                    ctrl.searchText = "";
                }
            });
        }
    }
});